import Persister from '../utils/LocalStoragePersister';
import PermissionsUtil from '../utils/PermissionsUtil';

/**
 * Check les permissions de l'utilisateur pour accéder à une route
 * Fais appel au PermissionUtil
 * Retourne vers une page de permission refusé si l'utilisateur n'a pas les droits
 * @param user
 * @param routePermissions
 * @returns {Function}
 * @constructor
 */
export default function CheckPermissions(user, routePermissions) {
  return (to, from, next) => {
    const permissions = user && user.permissions && user.permissions.length > 0 ? user.permissions : JSON.parse(Persister.get('user_permissions'));
    if (!permissions || (routePermissions && routePermissions.length > 0 && !PermissionsUtil.checkPermissions(permissions, routePermissions))) {
      next('/permission-denied');
    }
    next();
  };
}
